import { Box, Dimensions, Text } from '@factorialco/deprecated-design-system'
import { AtsCandidatesDataTableQuery } from 'generated/resources/datatable.graphql'

import * as styles from './Highlighted.vanilla.css'

type DataTableRow =
  AtsCandidatesDataTableQuery['ats']['candidatesConnection']['edges'][number]['node']

interface Props {
  candidate: DataTableRow
  fields: string[]
  minWidth: Dimensions
  children?: JSX.Element
  size?: '300' | '200' | '100'
}

export const Highlighted = ({ candidate, fields, minWidth, children, size }: Props) => {
  const highlightsMap = Object.fromEntries(
    candidate.searchResult?.highlights.map((highlight) => [highlight.field, highlight.content]) ||
      []
  )

  const highlightedContent = fields.flatMap((field) => highlightsMap[field] || [])?.at(0)
  if (!highlightedContent && !children) return null

  return (
    <Box key={`${fields[0]}_${candidate.id}`} className={styles.highlight} minWidth={minWidth}>
      {highlightedContent && (
        <Text.Normal size={size || '300'}>
          <div dangerouslySetInnerHTML={{ __html: highlightedContent }}></div>
        </Text.Normal>
      )}
      {!highlightedContent && children}
    </Box>
  )
}
